<div [ngClass]="{ 'multiple-becks-family-toggle': multipleFamilySelect }" class="becks-family-toggle">
  @if (!multipleFamilySelect) {
    @for (group of familyGroups; track group) {
      <mat-icon
        [ngClass]="{ selected: group.code === selectedFamilyGroup?.code, clickable: !isReadOnly }"
        [matTooltip]="group.desc"
        class="becks-family-toggle__option relative"
      >
        <lib-becks-svg [src]="group.iconPath" (click)="handleFamilyGroupSelected(group, $event)"></lib-becks-svg>
      </mat-icon>
    }
  }
  @if (multipleFamilySelect) {
    @for (group of familyGroups; track group; let i = $index) {
      <mat-icon
        [ngClass]="{ selected: group.code && selectedFamilyCodes?.includes(group.code), clickable: !isReadOnly }"
        [matTooltip]="group.desc"
        class="becks-family-toggle__option"
      >
        <lib-becks-svg [src]="group.iconPath" (click)="handleFamilyGroupSelected(group, $event)"></lib-becks-svg>
      </mat-icon>
    }
  }
</div>
